<!--Footer Starts-->
<footer class="footer" style="background-color: #e1dddd;;">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; {{currentDate | date: 'yyyy'}} <a id="pixinventLink"
      href="https://etranscargo.in">ACPLCARGO</a>
    <span class="d-none d-sm-inline-block">, All rights reserved.</span>
  </p>
</footer>
<!--Footer Ends-->
